import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from "../../base-api.service";
import {FamiliesExpensesModelService} from "../../../Models/Finances/Expenses/families-expenses-model.service";

@Injectable({
  providedIn: 'root'
})
export class FamiliesExpensesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: FamiliesExpensesModelService
  ) {
    super(injector);
  }


  /**
   * Obtener las familias de gastos
   *
   */
  public getFamiliesExpenses(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getFamiliasGastos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }
}
